import { IShippingAddress, IShippingMethod } from '@/models'
import { api } from '@/api/api'

export async function fetchShippingMethods(
    orderCode: string,
    shippingAddress: IShippingAddress
): Promise<IShippingMethod[]> {
    const {
        data: { methods },
    } = await api.post(`shipping/availableShippingMethods/${orderCode}`, { shippingAddress })

    return methods
}
